<template>
  <img :src="flagSvg.src" />
</template>

<script>
import flagAuSvg from '~/assets/flags/flag-au.svg'
import flagBeSvg from '~/assets/flags/flag-be.svg'
import flagDeSvg from '~/assets/flags/flag-de.svg'
import flagIeSvg from '~/assets/flags/flag-ie.svg'
import flagNlSvg from '~/assets/flags/flag-nl.svg'
import flagNzSvg from '~/assets/flags/flag-nz.svg'
import flagUkSvg from '~/assets/flags/flag-uk.svg'
import flagUsSvg from '~/assets/flags/flag-us.svg'

export default {
  props: {
    locale: {
      type: String,
      default: '',
    },
  },
  computed: {
    flagSvg() {
      switch (this.locale) {
      case 'de-DE':
        return flagDeSvg
      case 'en-AU':
        return flagAuSvg
      case 'en-GB':
        return flagUkSvg
      case 'en-IE':
        return flagIeSvg
      case 'en-NZ':
        return flagNzSvg
      case 'en-US':
        return flagUsSvg
      case 'fr-BE':
      case 'nl-BE':
        return flagBeSvg
      case 'nl-NL':
        return flagNlSvg
      }
    },
  },
}
</script>
